var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "map-pin",
    clipPath: "url(#clip0_126_3320)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14 7.16699C14 11.8337 8 15.8337 8 15.8337C8 15.8337 2 11.8337 2 7.16699C2 5.57569 2.63214 4.04957 3.75736 2.92435C4.88258 1.79913 6.4087 1.16699 8 1.16699C9.5913 1.16699 11.1174 1.79913 12.2426 2.92435C13.3679 4.04957 14 5.57569 14 7.16699Z",
    stroke: "#FFD700",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8 9.16699C9.10457 9.16699 10 8.27156 10 7.16699C10 6.06242 9.10457 5.16699 8 5.16699C6.89543 5.16699 6 6.06242 6 7.16699C6 8.27156 6.89543 9.16699 8 9.16699Z",
    stroke: "#FFD700",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_126_3320"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterMap);
export default __webpack_public_path__ + "static/media/footer_map.9b62c455f7979b2449846020afe618ef.svg";
export { ForwardRef as ReactComponent };